import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { ASSESSMENT_TYPES, ASSESSMENT_TYPE_LABEL } from "@/lib/assessmentTypes";

/** A5: assessment type shown in the assessment page; admin can set it (logged). */
export default function AssessmentTypeField({ assessmentId, isAdmin }) {
  const [a, setA] = useState(null);
  const [certs, setCerts] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = () => api.get(`/assessments/${assessmentId}`).then(({ data }) => setA(data)).catch(() => {});
  useEffect(() => { load(); }, [assessmentId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!isAdmin || !a) return;
    api.get("/assessments").then(({ data }) => setCerts(data.filter((x) => x.certificate_code && x.organization_id === a.organization_id && x.id !== a.id)));
  }, [isAdmin, a]);
  if (!a) return null;

  async function save() {
    try {
      await api.patch(`/assessments/${assessmentId}/admin-flags`, { assessment_type: edit.type, reference_certificate_code: edit.type === "prima_emissione" ? null : edit.ref });
      toast.success("Tipo assessment aggiornato"); setEdit(null); load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  }

  return (
    <div className="inline-flex flex-wrap items-center gap-2 text-xs text-slate-600 bg-white border border-slate-200 rounded-full px-3 py-1.5" data-testid="assessment-type-field">
      <span className="font-semibold">Tipo:</span>
      {!edit ? (
        <>
          <span data-testid="assessment-type-value">{ASSESSMENT_TYPE_LABEL[a.assessment_type] || "Non specificato"}</span>
          {a.reference_certificate_code && <span className="font-mono text-slate-400">rif. {a.reference_certificate_code}</span>}
          {isAdmin && <button className="text-viva-600 font-semibold" onClick={() => setEdit({ type: a.assessment_type || "prima_emissione", ref: a.reference_certificate_code || "" })} data-testid="assessment-type-edit">Modifica</button>}
        </>
      ) : (
        <>
          <Select value={edit.type} onValueChange={(v) => setEdit({ ...edit, type: v })}>
            <SelectTrigger className="h-7 w-40" data-testid="assessment-type-select"><SelectValue /></SelectTrigger>
            <SelectContent>{ASSESSMENT_TYPES.map((t) => <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>)}</SelectContent>
          </Select>
          {edit.type !== "prima_emissione" && (
            <Select value={edit.ref} onValueChange={(v) => setEdit({ ...edit, ref: v })}>
              <SelectTrigger className="h-7 w-48" data-testid="assessment-ref-select"><SelectValue placeholder="Certificato di riferimento" /></SelectTrigger>
              <SelectContent>{certs.map((c) => <SelectItem key={c.id} value={c.certificate_code}>{c.certificate_code} · {c.year}</SelectItem>)}</SelectContent>
            </Select>
          )}
          <Button size="sm" className="h-7" onClick={save} data-testid="assessment-type-save">Salva</Button>
          <Button size="sm" variant="ghost" className="h-7" onClick={() => setEdit(null)}>Annulla</Button>
        </>
      )}
    </div>
  );
}
